export const switchValues = ['Uitgeschakeld', 'Ingeschakeld'];
